import dayjs from "@gtmhub/dayjs";
import { allowedActionsSync } from "@gtmhub/permissions/utils";
import { IUser } from "@gtmhub/users";
import { byDateField } from "@gtmhub/util/sorting";
import { IPlanningSession, PlanningSessionStatus } from "../models/models";

export function isActiveSession(s: IPlanningSession) {
  const now = dayjs.utc();
  return s.status !== PlanningSessionStatus.ARCHIVED && !s.demo && now.isSameOrAfter(s.start) && now.isSameOrBefore(s.end);
}

export function getClosestOpenActiveSession(sessions: IPlanningSession[], user: IUser): IPlanningSession {
  const activeSessionsSortedByEndDateAsc = filterOpenActiveSessionsWithPermissionToCreate(sessions, user).sort(byDateField("end"));
  return activeSessionsSortedByEndDateAsc.length ? activeSessionsSortedByEndDateAsc[0] : undefined;
}

export function filterOpenActiveSessionsWithPermissionToCreate(sessions: IPlanningSession[], user: IUser): IPlanningSession[] {
  const now = dayjs.utc();
  return sessions.filter(
    (s) =>
      s.status === PlanningSessionStatus.OPEN &&
      !s.demo &&
      now.isSameOrAfter(s.start) &&
      now.isSameOrBefore(s.end) &&
      allowedActionsSync(user, s.access).includes("create")
  );
}

export function filterActiveSessions(sessions: IPlanningSession[]): IPlanningSession[] {
  return sessions.filter(isActiveSession);
}

export function filterActiveSessionsWithoutCheckDate(sessions: IPlanningSession[]): IPlanningSession[] {
  return sessions.filter((s) => s.status !== PlanningSessionStatus.ARCHIVED && !s.demo);
}

export function filterActiveSessionsAllStatuses(sessions: IPlanningSession[]): IPlanningSession[] {
  const now = dayjs.utc();
  return sessions.filter((s) => !s.demo && now.isSameOrAfter(s.start) && now.isSameOrBefore(s.end));
}

export function filterActiveAndFutureSessions(sessions: IPlanningSession[]): IPlanningSession[] {
  const now = dayjs.utc();
  return sessions.filter((s) => s.status !== PlanningSessionStatus.ARCHIVED && !s.demo && now.isSameOrBefore(s.end));
}

export function filterOpenedActiveAndFutureSessions(sessions: IPlanningSession[]): IPlanningSession[] {
  const now = dayjs.utc();
  return sessions.filter((s) => s.status === PlanningSessionStatus.OPEN && !s.demo && now.isSameOrBefore(s.end));
}

export function getSessionAndOneLevelChildren(sessions: IPlanningSession[], sessionId: string): IPlanningSession[] {
  return sessions.filter((s) => s.id === sessionId || s.parentId === sessionId);
}

export function filterOpenedActiveAndFutureSessionsAndOneLevelChildren(sessions: IPlanningSession[], sessionId: string): IPlanningSession[] {
  return sessions.filter((s) => s.status === PlanningSessionStatus.OPEN && !s.demo && dayjs().isSameOrBefore(s.end) && (s.id === sessionId || s.parentId === sessionId));
}

export function getSessionDurationInDays(session: IPlanningSession): number {
  return dayjs(session.end).diff(session.start, "days");
}
